import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SidebarBottomIcon = React.forwardRef(function SidebarBottomIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2C3.80228 2 2 3.80228 2 6V18C2 20.1977 3.80228 22 6 22H18C20.1977 22 22 20.1977 22 18V6C22 3.80228 20.1977 2 18 2H6ZM0 6C0 2.69772 2.69772 0 6 0H18C21.3023 0 24 2.69772 24 6V18C24 21.3023 21.3023 24 18 24H6C2.69772 24 0 21.3023 0 18V6Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 19H1V17H23V19ZM7.2 10.4C7.53137 9.95817 8.15817 9.86863 8.6 10.2L12 12.75 15.4 10.2C15.8418 9.86863 16.4686 9.95817 16.8 10.4 17.1314 10.8418 17.0418 11.4686 16.6 11.8L12 15.25 7.4 11.8C6.95817 11.4686 6.86863 10.8418 7.2 10.4Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C12.5523 5 13 5.44772 13 6V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V6C11 5.44772 11.4477 5 12 5Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

SidebarBottomIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SidebarBottomIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SidebarBottomIcon
